<!--
 * @Author: maxwellllu
 * @Date: 2023-05-05 16:48:29
 * @LastEditors: maxwellllu
 * @LastEditTime: 2023-06-07 16:19:45
 * @FilePath: /privatization-webim/src/components/message-items/MsgGray/index.vue
 * @Description:
-->
<template>
  <div class="msg-gray">
    <gray-card
      v-if="hasExtuinInfo"
      :processedText="processedText"
      :text="text"
      :uin-info="uinInfo"
    ></gray-card>
    <span
      v-html="processedText"
      :class="device"
      ref="grayText"
      v-else
    ></span>
  </div>
</template>

<script>
import Utils from '@/utils/string';
import GrayCard from './gray-card.vue';
import globalWin from '@/utils/globalWin';
import { handleLinkClick } from '@/utils/bindlLinkClick.js';
import { IMSDK } from '@/imsdk/index';
const imsdk = IMSDK.create();

export default {
  components: {
    GrayCard,
  },
  props: {
    device: {
      type: String,
      default: 'pc',
    },
    data: Object,
  },
  computed: {
    text() {
      return this.data?.content?.gray;
    },
    uinInfo() {
      return this.data?.crm?.msg_webim_extra_data;
    },
    hasExtuinInfo() {
      /* eslint-disable max-len */
      return this.uinInfo?.str_avatar && this.uinInfo?.str_external_name;
    },
    processedText() {
      let text = this.data?.content?.gray || '';
      // 过滤html，保留a标签
      text = Utils.filterHTML(text);
      text = text.replace('\r\n', '<br>');
      return text;
    },
  },
  methods: {
    handleGrayLinkClick() {
      const textEl = this.$refs.grayText;
      if (textEl) {
        const linkEl = textEl.querySelectorAll('a');
        linkEl.forEach((item) => {
          item.addEventListener('click', (e) => {
            const type = item.getAttribute('data-type');
            let url = item.getAttribute('href') || '';
            // 这个type的逻辑仅在广交会的场景使用，后续全走通用逻辑，不要在这里加else
            if (type && type === 'changeLang') {
              globalWin.switchSetLangPanel(true);
              return;
            }
            e.preventDefault();
            url = this.preHandleUrl(url);
            handleLinkClick(url);
          });
        });
      }
    },
    preHandleUrl(url) {
      const PROTOCOL_PREFIX = /qdweb/;
      if (!url) {
        return url;
      }
      if (PROTOCOL_PREFIX.test(url) && url.indexOf('pageaction') > -1) {
        const paramsPrefix = url.indexOf('?') > -1 ? '&' : '?';
        return `${url}${paramsPrefix}grayMsgSeq=${this?.data?.seq}`;
      }
      return url;
    },
  },
  beforeMount() {
    // 已填写的表单下发时不展示填写按钮
    const tags = imsdk.getMessageTags(this.data);
    const deleteLink = tags.find(item => item.tag === 'delete_gray_link');
    if (deleteLink && deleteLink.value === '1') {
      const message = this.data;
      const grayContent = message?.content?.gray;
      if (grayContent) {
        this.data.content.gray = grayContent.replace(/<a\b[^>]*>(.*?)<\/a>/gi, '');
      }
    }
  },
  mounted() {
    // 处理a链接点击事件
    this.handleGrayLinkClick();
  },
};
</script>

<style lang="less" scoped>
.msg-gray {
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  span {
    border-radius: 12px;
    padding: 2px 12px;
    display: inline-block;
    color: #B4B8C4;
    &.pc {
      background: #eceef1;
    }
    &.h5 {
      border-radius: 6px;
      background: #fff;
    }
  }
}
</style>
